module.exports = __webpack_public_path__ + "static/media/danskeheadlinebold-webfont.4869eba1.eot";